var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"GoodsItem2"},[_c('van-image',{staticClass:"pic",attrs:{"fit":"cover","src":"","error-icon":"photo"}}),_c('div',{staticClass:"rightPart"},[_c('van-skeleton',{staticClass:"mySkeleton",attrs:{"title":"","row":2}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }